import { render, staticRenderFns } from "./Simple-pagination.vue?vue&type=template&id=15858dc2"
import script from "./Simple-pagination.vue?vue&type=script&lang=js"
export * from "./Simple-pagination.vue?vue&type=script&lang=js"
import style0 from "./Simple-pagination.vue?vue&type=style&index=0&id=15858dc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports